module.exports = __webpack_public_path__ + "public/images/modals/netw-find-member-desktop.374a5a33a403c5c5dd9eee2c8a6927af.png";